import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Brands from "@/components/sections/Brands";
import WhyChoose from "@/components/sections/WhyChoose";
import Leadership from "@/components/sections/Leadership";
import ServiceArea from "@/components/sections/ServiceArea";
import Reviews from "@/components/sections/Reviews";
import LeadForm from "@/components/sections/LeadForm";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Brands />
        <WhyChoose />
        <Leadership />
        <ServiceArea />
        <Reviews />
        <LeadForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
